import { observer } from 'mobx-react';
import React from 'react';

import ScormPlayer from 'components/ScormPlayer';

import { IChunkModel } from '@common/models/Chunks/Chunk';
import { IGradeBookModel } from '@common/models/GradeBooks/GradeBook';

import { StyledChunkScormWrap } from './style';

interface PropsType {
	chunkModel: IChunkModel;
	gradeBook: IGradeBookModel;
	disabled?: boolean;
}

function ChunkScorm({ chunkModel, gradeBook, disabled }: PropsType) {
	return (
		<>
			{chunkModel.scorms.map((scorm) => (
				<StyledChunkScormWrap key={scorm.id}>
					<ScormPlayer scorm={scorm} gradeBook={gradeBook} isReloadButtonWithNoData={disabled} />
				</StyledChunkScormWrap>
			))}
		</>
	);
}

export default observer(ChunkScorm);
